import React from 'react';
import type { TaskStatus, ProjectStatus } from '@/lib/mockData';

type AnyStatus = TaskStatus | ProjectStatus;

interface StatusBadgeProps {
  status: AnyStatus;
}

export default function StatusBadge({ status }: StatusBadgeProps) {
  const classMap: Record<string, string> = {
    'To Do': 'status-badge-todo',
    'In Progress': 'status-badge-inprogress',
    'In Review': 'status-badge-inreview',
    Done: 'status-badge-done',
    Active: 'status-badge-active',
    'On Hold': 'status-badge-onhold',
    Completed: 'status-badge-completed',
  };

  return (
    <span className={classMap[status] ?? 'status-badge-todo'}>
      {status}
    </span>
  );
}